<template>
  <section class="tech sec sec-tint">
    <div class="page">
      <SectionHeading
        eyebrow="Technology Base"
        title="一套技术底座，支撑三类现场"
        desc="终端、边缘、平台到前端同一支团队自研，问题定位不推诿，需求迭代不排队。"
      />

      <div class="tech-grid">
        <div
          v-for="(t, i) in techBase"
          :key="t.title"
          class="tech-card card card-pad reveal"
          v-reveal="{ delay: i * 80 }"
        >
          <div class="tech-icon"><IconSvg :name="t.icon"/></div>
          <h3 class="tech-title">{{ t.title }}</h3>
          <p class="tech-desc">{{ t.desc }}</p>
          <span class="tech-index">0{{ i + 1 }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SectionHeading from '@/components/common/SectionHeading'
import IconSvg from '@/components/common/IconSvg'
import { techBase } from '@/data/site'

export default {
  name: 'TechBaseSection',
  components: { SectionHeading, IconSvg },
  data() {
    return { techBase }
  }
}
</script>

<style lang="scss" scoped>
.tech { position: relative; }

.tech-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
}

.tech-card {
  padding: 30px 28px 34px;
  min-height: 216px;

  .tech-index {
    position: absolute;
    top: 20px;
    right: 22px;
    font-size: 30px;
    font-weight: 800;
    color: rgba(120, 176, 255, 0.12);
    letter-spacing: -0.02em;
    transition: color 0.4s;
  }

  &:hover .tech-index { color: rgba(34, 224, 255, 0.28); }
  &:hover .tech-icon { border-color: var(--cyan); color: var(--cyan); box-shadow: var(--glow-cyan); }
}

.tech-icon {
  width: 52px;
  height: 52px;
  padding: 13px;
  border-radius: 14px;
  border: 1px solid var(--line-strong);
  color: var(--txt-2);
  background: rgba(255, 255, 255, 0.03);
  transition: all 0.4s;
}

.tech-title {
  margin-top: 22px;
  font-size: 19px;
  color: #fff;
}

.tech-desc {
  margin-top: 12px;
  font-size: 14px;
  line-height: 1.85;
  color: var(--txt-3);
}

@media (max-width: 1080px) {
  .tech-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 640px) {
  .tech-grid { grid-template-columns: minmax(0, 1fr); gap: 16px; }
  .tech-card { min-height: 0; padding: 24px 22px 26px; }
}
</style>
